import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const sayfaStyle = { minHeight: '100vh', background: '#0f1117', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: '32px 16px 60px' };
const kartStyle = { width: '100%', maxWidth: 480, background: '#161921', borderRadius: 16, padding: 24, border: '1px solid #2a2d3a' };
const labelStyle = { display: 'block', color: '#aaa', fontSize: 12, marginBottom: 6, fontWeight: 600 };
const inputStyle = { width: '100%', background: '#1a1d27', border: '1px solid #2a2d3a', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

const IBAN = 'TR17 0006 7010 0000 0081 5708 75';
const HESAP_ADI = 'LEVENT POSTALCIOĞLU';
const BANKA = 'Yapı Kredi';

export default function FaturaliHavaleSayfasi() {
  const { siparisNo } = useParams();
  const [durum, setDurum] = useState('yukleniyor');
  const [mesaj, setMesaj] = useState('');
  const [siparis, setSiparis] = useState(null);
  const [kalemler, setKalemler] = useState([]);
  const [faturaVar, setFaturaVar] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [form, setForm] = useState({
    ad_soyad: '', telefon: '', adres: '',
    fatura_ad: '', vergi_no: '', vergi_dairesi: '', fatura_adres: '',
  });

  useEffect(() => { fetchSiparis(); }, [siparisNo]);

  async function fetchSiparis() {
    try {
      const { data: s, error } = await supabase
        .from('siparisler')
        .select('id, siparis_no, toplam_tutar, odeme_durumu, musteri_id, firma_id, adres, not_')
        .eq('siparis_no', siparisNo)
        .single();

      if (error || !s) { setDurum('hata'); setMesaj('Sipariş bulunamadı.'); return; }
      if (s.odeme_durumu === 'odendi') { setSiparis(s); setDurum('tamamlandi'); return; }

      let firmaAd = '';
      if (s.firma_id) {
        const { data: f } = await supabase.from('firmalar').select('ad').eq('id', s.firma_id).single();
        firmaAd = f?.ad || '';
      }

      if (s.musteri_id) {
        const { data: m } = await supabase.from('musteriler').select('ad, telefon, adres, vergi_no, vergi_dairesi, fatura_ad, fatura_adres').eq('id', s.musteri_id).single();
        if (m) {
          setFaturaVar(!!(m.vergi_no || m.fatura_ad));
          setForm({ ad_soyad: m.ad || '', telefon: m.telefon || '', adres: s.adres || m.adres || '', fatura_ad: m.fatura_ad || m.ad || '', vergi_no: m.vergi_no || '', vergi_dairesi: m.vergi_dairesi || '', fatura_adres: m.fatura_adres || m.adres || '' });
        }
      }

      const { data: k } = await supabase.from('siparis_kalemleri').select('id, miktar, toplam, urun_id').eq('siparis_id', s.id);
      const kalemlerDetay = await Promise.all((k || []).map(async kalem => {
        const { data: u } = await supabase.from('urunler').select('ad').eq('id', kalem.urun_id).single();
        return { ...kalem, urun_ad: u?.ad || '' };
      }));

      setSiparis({ ...s, firma_ad: firmaAd });
      setKalemler(kalemlerDetay);
      setDurum('form');
    } catch (e) {
      setDurum('hata');
      setMesaj('Bir hata oluştu: ' + e.message);
    }
  }

  async function handleGonder() {
    if (!form.fatura_ad.trim()) { setHata('Fatura adı gerekli'); return; }
    if (!form.vergi_no.trim()) { setHata('Vergi No / TC No gerekli'); return; }
    setHata(''); setYukleniyor(true);
    try {
      if (siparis.musteri_id) {
        await supabase.from('musteriler').update({ ad: form.ad_soyad, telefon: form.telefon, adres: form.adres, fatura_ad: form.fatura_ad, vergi_no: form.vergi_no, vergi_dairesi: form.vergi_dairesi, fatura_adres: form.fatura_adres }).eq('id', siparis.musteri_id);
      }
      await supabase.from('siparisler').update({ adres: form.adres, not_: 'Fatura bilgileri iletildi. Dekont bekleniyor.' }).eq('id', siparis.id);
      setDurum('tamamlandi');
    } catch (e) { setHata('Hata: ' + e.message); }
    setYukleniyor(false);
  }

  if (durum === 'yukleniyor') return (
    <div style={sayfaStyle}><div style={kartStyle}><p style={{ color: '#aaa', textAlign: 'center', padding: 40 }}>Yükleniyor...</p></div></div>
  );

  if (durum === 'hata') return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <h2 style={{ color: '#fff', marginBottom: 12, fontSize: 18 }}>Sayfa Açılamadı</h2>
          <p style={{ color: '#888', fontSize: 14 }}>{mesaj}</p>
        </div>
      </div>
    </div>
  );

  if (durum === 'tamamlandi') return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
          <h2 style={{ color: '#4ade80', marginBottom: 8, fontSize: 22 }}>Bilgiler Alındı!</h2>
          <p style={{ color: '#aaa', fontSize: 14 }}>Sipariş No: <strong style={{ color: '#fff' }}>#{siparisNo}</strong></p>
        </div>
        <div style={{ background: '#1a1d27', borderRadius: 10, padding: 16, marginBottom: 16, textAlign: 'center' }}>
          <p style={{ color: '#aaa', fontSize: 13, marginBottom: 4 }}>Ödenecek Tutar</p>
          <p style={{ color: '#E07B00', fontSize: 28, fontWeight: 900 }}>{(siparis?.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</p>
          <p style={{ color: '#aaa', fontSize: 12, marginTop: 4 }}>🏦 Banka Havalesi (Faturalı)</p>
        </div>
        <div style={{ background: '#1a1d27', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <p style={{ color: '#aaa', fontSize: 12, marginBottom: 8, fontWeight: 600 }}>ÖDEME BİLGİLERİ</p>
          <p style={{ color: '#fff', fontSize: 13, marginBottom: 4 }}><span style={{ color: '#aaa' }}>Banka:</span> {BANKA}</p>
          <p style={{ color: '#fff', fontSize: 13, marginBottom: 8 }}><span style={{ color: '#aaa' }}>Hesap Adı:</span> {HESAP_ADI}</p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#0f1117', borderRadius: 8, padding: '10px 12px' }}>
            <span style={{ color: '#fff', fontSize: 13, fontFamily: 'monospace', fontWeight: 700 }}>{IBAN}</span>
            <button onClick={() => { navigator.clipboard.writeText(IBAN.replace(/\s/g, '')); alert('IBAN kopyalandı!'); }}
              style={{ background: '#E07B00', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 12, padding: '6px 10px', fontWeight: 700, marginLeft: 8, whiteSpace: 'nowrap' }}>
              📋 Kopyala
            </button>
          </div>
        </div>
        <div style={{ background: 'rgba(224,123,0,0.1)', border: '1px solid rgba(224,123,0,0.3)', borderRadius: 10, padding: 14 }}>
          <p style={{ color: '#E07B00', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>📌 Önemli</p>
          <p style={{ color: '#aaa', fontSize: 13, lineHeight: 1.6 }}>Havale açıklamasına <strong style={{ color: '#fff' }}>#{siparisNo}</strong> yazınız. Dekontunuzu WhatsApp üzerinden temsilcinize iletiniz. 🙏</p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={sayfaStyle}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#E07B00' }}>{siparis?.firma_ad || 'Ödeme'}</div>
        <div style={{ color: '#888', fontSize: 14, marginTop: 4 }}>Faturalı Banka Havalesi Formu</div>
      </div>
      <div style={kartStyle}>
        <div style={{ marginBottom: 20, padding: 14, background: '#1a1d27', borderRadius: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <span style={{ color: '#888', fontSize: 13 }}>Sipariş No</span>
            <span style={{ color: '#fff', fontWeight: 700, fontFamily: 'monospace' }}>#{siparisNo}</span>
          </div>
          {kalemler.map(k => (
            <div key={k.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginTop: 6 }}>
              <span style={{ color: '#bbb' }}>{k.urun_ad} ×{k.miktar}</span>
              <span style={{ color: '#fff' }}>{(k.toplam || 0).toLocaleString('tr-TR')} ₺</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #2a2d3a', paddingTop: 10, marginTop: 10 }}>
            <span style={{ color: '#888' }}>Toplam</span>
            <span style={{ color: '#E07B00', fontWeight: 800, fontSize: 18 }}>{(siparis?.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</span>
          </div>
          <p style={{ color: '#666', fontSize: 12, marginTop: 6 }}>🏦 Banka Havalesi (Faturalı)</p>
        </div>

        <h3 style={{ color: '#fff', fontSize: 15, fontWeight: 700, marginBottom: 16 }}>Bilgilerinizi Onaylayın</h3>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Ad Soyad *</label>
          <input style={inputStyle} value={form.ad_soyad} onChange={e => setForm(f => ({ ...f, ad_soyad: e.target.value }))} placeholder="Adınız Soyadınız" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Telefon</label>
          <input style={inputStyle} value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))} placeholder="05XX XXX XX XX" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Teslimat Adresi</label>
          <textarea style={{ ...inputStyle, minHeight: 70, resize: 'vertical' }} value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} placeholder="Teslimat adresiniz..." />
        </div>

        <div style={{ height: 1, background: '#2a2d3a', margin: '16px 0' }} />
        <p style={{ color: '#E07B00', fontSize: 12, fontWeight: 700, marginBottom: 8 }}>🧾 FATURA BİLGİLERİ</p>
        <p style={{ color: faturaVar ? '#4ade80' : '#aaa', fontSize: 12, marginBottom: 14 }}>
          {faturaVar ? '✓ Kayıtlı bilgileriniz getirildi, değiştirebilirsiniz.' : 'Bir kez doldurun, sonraki siparişlerde otomatik gelir.'}
        </p>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Fatura Adı / Şirket Adı *</label>
          <input style={inputStyle} value={form.fatura_ad} onChange={e => setForm(f => ({ ...f, fatura_ad: e.target.value }))} placeholder="Ad Soyad veya Şirket Adı" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Vergi No / TC No *</label>
          <input style={inputStyle} value={form.vergi_no} onChange={e => setForm(f => ({ ...f, vergi_no: e.target.value }))} placeholder="Vergi veya TC kimlik no" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Vergi Dairesi</label>
          <input style={inputStyle} value={form.vergi_dairesi} onChange={e => setForm(f => ({ ...f, vergi_dairesi: e.target.value }))} placeholder="Vergi dairesi adı" />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={labelStyle}>Fatura Adresi</label>
          <textarea style={{ ...inputStyle, minHeight: 70, resize: 'vertical' }} value={form.fatura_adres} onChange={e => setForm(f => ({ ...f, fatura_adres: e.target.value }))} placeholder="Fatura adresi..." />
        </div>

        {hata && <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: 13, marginBottom: 16 }}>⚠️ {hata}</div>}

        <button onClick={handleGonder} disabled={yukleniyor}
          style={{ width: '100%', padding: 14, borderRadius: 10, border: 'none', background: yukleniyor ? '#555' : '#E07B00', color: '#fff', fontWeight: 700, fontSize: 16, cursor: yukleniyor ? 'not-allowed' : 'pointer' }}>
          {yukleniyor ? '⏳ Kaydediliyor...' : '✓ Bilgileri Onayla →'}
        </button>
        <p style={{ textAlign: 'center', color: '#555', fontSize: 11, marginTop: 12 }}>🔒 Bilgileriniz güvende.</p>
      </div>
    </div>
  );
}
